import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-59e638da")

_pushScopeId("data-v-59e638da")
const _hoisted_1 = { class: "line-container" }
const _hoisted_2 = { class: "line-title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "line-bottom" }, null, -1)
const _hoisted_4 = { class: "line-box" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "keepout-top" }, null, -1)
const _hoisted_6 = { class: "line-box-left" }
const _hoisted_7 = { class: "line-box-num" }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "line-num-shadow" }, "STEP", -1)
const _hoisted_10 = { class: "line-box-right" }
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "tag-group" }
const _hoisted_13 = {
  key: 0,
  class: "tag-item"
}
const _hoisted_14 = { class: "tag-group" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.baseInfo.moduleName), 1),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.baseInfo.detailVOS, (itemLine, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "line-box-content"
        }, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("span", null, "0" + _toDisplayString(index + 1), 1),
              _hoisted_8,
              _hoisted_9
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("span", null, [
              _createVNode("i", null, _toDisplayString(itemLine.fieldName), 1),
              _hoisted_11,
              _createTextVNode(" 时间：" + _toDisplayString(itemLine.operateTime), 1 /* TEXT */)
            ]),
            _createVNode("div", _hoisted_12, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemLine.attaches || [], (v, index) => {
                return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                  (v?.urls?.length === 0)
                    ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(v.name), 1))
                    : _createCommentVNode("", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createVNode("div", _hoisted_14, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemLine.attaches || [], (v, index) => {
                return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                  (v?.urls?.length)
                    ? (_openBlock(), _createBlock("span", {
                        key: 0,
                        class: "tag-item tag-item-active",
                        onClick: $event => (_ctx.showDetails(itemLine))
                      }, _toDisplayString(v.name), 9, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
})